import { ConfirmationDialog } from "common/styleguide/ConfirmationDialog";
import { experienceApi, experienceSelectors } from "data/resources/experiences";
import { errorMessage } from "lib/styleguide/base.scss";
import React from "react";
import { connect } from "react-redux";

export const DELETE_EXPERIENCE_DIALOG = "DELETE_EXPERIENCE_DIALOG";

export class _DeleteExperienceDialog extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      deletePending: false,
      deleteError: false,
    };
  }

  onConfirm = () => {
    const { experience } = this.props;

    this.setState({ deletePending: true });
    experienceApi
      .delete(experience.id)
      .then(() => {
        window.location = `/organizations/${experience.clubId}/experiences`;
      })
      .catch(() => this.setState({ deletePending: false, deleteError: true }));
  };

  render() {
    const { experience, onRequestClose } = this.props;
    const { deletePending, deleteError } = this.state;

    if (!experience) return <div />;

    return (
      <ConfirmationDialog
        confirmText="Yes, Delete this Experience"
        onRequestClose={onRequestClose}
        onCancel={onRequestClose}
        onConfirm={this.onConfirm}
        confirmPending={deletePending}
        danger
      >
        <p>
          Deleting this Experience cannot be undone. All details, guide pages, and guest content will be permanently
          removed.
        </p>
        {deleteError && (
          <div className={errorMessage}>We encountered an error while deleting this Experience. Please try again.</div>
        )}
      </ConfirmationDialog>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  experience: experienceSelectors.find(state, ownProps.experienceId),
});

export const DeleteExperienceDialog = connect(mapStateToProps, null)(_DeleteExperienceDialog);
